import React, { useEffect, useState } from 'react';
import { warName } from '../..';
import { getEnv } from '../env';

function importJsBarcode(callback) {
	const script = document.createElement('script');
	script.async = 1;
	const apiDomain = getEnv('REACT_APP_API_DOMAIN');
	script.src = `${apiDomain}/${warName}/content/js/lib/barcode/JsBarcode.all.min.js`;
	script.onload = callback;
	const node = document.getElementsByTagName('script')[0];
	node.parentNode.insertBefore(script, node);
}

function getBarcode(source, showValue = false) {
	const barcode = document.createElement('img');
	barcode.id = 'barcode';
	barcode.setAttribute('style', 'height: 50px; width: 100%; display: none;');
	document.body.appendChild(barcode);

	const settings = {
		format: 'CODE128',
		height: 60,
	};
	if (!showValue) {
		settings.width = 1;
		settings.displayValue = false;
	}

    window.JsBarcode("#barcode", source, settings);
    return barcode.src;	
}

export default function BarcodeImg(props) {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        if (window.JsBarcode == null) {
            importJsBarcode(() => {
                setSrc(getBarcode(props.source, props.showValue))
            });
        } else {
            setSrc(getBarcode(props.source, props.showValue))
        }
    }, [props.showValue, props.source]);

    if (src == null) {
        return null;
    }

    return <img alt={props.source} src={src} style={props.style} />;
}
